import { render } from "./DateFormatSelect.vue?vue&type=template&id=26097e52"
import script from "./DateFormatSelect.vue?vue&type=script&lang=js"
export * from "./DateFormatSelect.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__